import React from "react";
import LoginOverlay from "@/components/LoginOverlay";
import { useAuth } from "@/lib/auth";

/**
 * AuthShell — gates the whole site behind the login overlay.
 * - While the initial /auth/me check is running, render nothing
 *   (avoids the brief flash of the public site before the gate appears).
 * - If no user, render the LoginOverlay full-screen.
 * - If authenticated, render children (the regular routed app).
 */
export default function AuthShell({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === undefined) {
    return (
      <div
        className="fixed inset-0 z-[100] flex items-center justify-center"
        style={{ backgroundColor: "#151E2B" }}
        data-testid="auth-loading"
      >
        <span className="eyebrow text-ivory/55">Connecting…</span>
      </div>
    );
  }

  if (!user) {
    return <LoginOverlay />;
  }

  return <>{children}</>;
}
